module.exports = __webpack_public_path__ + "91610edfe033a9031b24ec85df598888.svg";